import { cva, type VariantProps } from 'class-variance-authority';

export { default as Badge } from './Badge.vue';

export const badgeVariants = cva(
  'inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90',
        secondary: 'border-transparent bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90',
        destructive:
          'border-transparent bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60',
        outline: 'text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground',
        gray: 'border-transparent bg-gray-100 text-gray-800 rounded-full font-semibold text-xs leading-5',
        blue: 'border-transparent bg-blue-100 text-blue-800 rounded-full font-semibold text-xs leading-5',
        'blue-dark': 'border-transparent bg-blue-500 text-white rounded-full font-semibold text-xs leading-5',
        green: 'border-transparent bg-green-100 text-green-800 rounded-full font-semibold text-xs leading-5',
        'green-dark': 'border-transparent bg-green-500 text-white rounded-full font-semibold text-xs leading-5',
        red: 'border-transparent bg-red-100 text-red-800 rounded-full font-semibold text-xs leading-5',
        yellow: 'border-transparent bg-yellow-100 text-yellow-800 rounded-full font-semibold text-xs leading-5',
        'yellow-dark': 'border-transparent bg-yellow-500 text-white rounded-full font-semibold text-xs leading-5',
        purple: 'border-transparent bg-purple-100 text-purple-800 rounded-full font-semibold text-xs leading-5',
        indigo: 'border-transparent bg-indigo-100 text-indigo-800 rounded-full font-semibold text-xs leading-5',
        'indigo-dark': 'border-transparent bg-indigo-700 text-white rounded-full font-semibold text-xs leading-5',
      },
      capitalize: {
        true: 'capitalize',
        false: '',
      },
    },
    defaultVariants: {
      variant: 'default',
      capitalize: true,
    },
  }
);
export type BadgeVariants = VariantProps<typeof badgeVariants>;
